import {Stack, Grid, Typography, Divider, Container, IconButton, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import React from 'react'


const Footer = () => {
  return (
    <div>
        <Stack sx={{marginTop: 'auto', bgcolor: '#595959', color: '#fcfcfc', width: '100%'}}>
            <Container>
                <Grid container spacing={8} sx={{ mt: 1, mb: 1, pr:4, pl: 5}}>
                    <Grid xs={4} md={4}>
                        <Container sx={{ textAlign: 'center' }}>
                            <Typography variant= 'h5' sx={{ mt: 2, mb: 2}}>About</Typography>
                            <Typography variant= 'subtitle2'>
                                Nurturing Discussions by Africans
                                for Africa's Growth & Development
                            </Typography>
                            {/*
                            <Typography variant= 'subtitle2'>
                                Our Eclectic Society instigates discussions 
                                around the elements that affect us as humans 
                                and most importantly as Africans for our own
                                Growth and Development and for 
                                the betterment of future generations to come.
                            </Typography>
                            */}
                        </Container>
                    </Grid>
                    <Grid xs={4} md={4}>
                        <Container sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ mt: 2, mb: 2}}>Visuals</Typography>
                            <Typography variant="subtitle1">
                                <Link color={'#fcfc19'} href='/visuals'>Check this out</Link>
                            </Typography>
                        </Container>
                    </Grid>
                    <Grid xs={4} md={4}>
                        <Container sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ mt: 2, mb: 2, mx: 4}}>Contacts</Typography>
                            <p>
                                <IconButton >
                                <PhoneIcon sx={{color:'white'}} />
                                <Typography variant="subtitle1" sx={{color:'white', pl: 1}}>+254 714859324</Typography>
                                </IconButton>
                            </p>
                            <p>
                                <IconButton >
                                <EmailIcon sx={{color:'white'}} />
                                <Typography variant="subtitle1" sx={{color:'white', pl: 1}}>
                                    oursociety
                                    .2022
                                    @gmail.com</Typography>
                                </IconButton>
                            </p>
                            {/* <p>
                                <IconButton >
                                    <FaceIcon fontSize='large' sx={{color:'white'}}/>
                                    <Typography variant="subtitle1" sx={{color:'white', pl: 1}}>Talk to bot</Typography>
                                </IconButton>
                            </p> */}
                        </Container>
                    </Grid>
                </Grid>

                <Divider sx={{ bgcolor: "white" }} variant='fullwidth'/>

                <Typography sx={{ mx:2, my:1 }}>Copyright © 2025 </Typography>
                <Typography sx={{ mx:2, my:1 }}>Powered By </Typography>
            </Container>
        </Stack>
    </div>
  )
}

export default Footer